<template>
  <v-dialog v-model="dialog" fullscreen>
    <v-btn slot="activator" color="primary" dark>
      Bulk Import Vehicles
    </v-btn>
    <v-toolbar color="primary">
      <v-spacer></v-spacer>
      <v-btn icon flat @click="dialog = false">
        <v-icon color="white">close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card>
      <v-container>
        <v-card-title>
          <span class="headline">Bulk Add Vehicles</span>
        </v-card-title>
        <v-card-text>
          <v-autocomplete v-model="Customer" :items="customerList" :loading="gettingCustomers" label="Select a Customer" item-text="name"
            item-value="key" required :rules="[v => !!v || 'Customer is required']" :disabled="customerFixed"></v-autocomplete>
          <v-autocomplete label="Site" v-model="Site" :items="sites" item-text="name" item-value="key" clearable
            append-outer-icon="mdi-plus"
            @click:append-outer="siteDialog = true"
          ></v-autocomplete>
          <v-dialog v-model="siteDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card>
              <v-toolbar dark color="primary">
                <v-btn icon dark @click="siteDialog = false">
                  <v-icon>close</v-icon>
                </v-btn>
                <v-toolbar-title>Sites</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                  <v-btn dark flat @click="siteDialog = false">Save</v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <v-layout>
                <sites-view v-if="siteDialog" />
              </v-layout>
            </v-card>
          </v-dialog>
          <v-textarea v-model="excelInput" label="Excel Data Input"></v-textarea>
          <v-layout row>
            <v-checkbox v-model="includeHeaders" label="Input includes header row"></v-checkbox>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="processRawData" :disabled="!Site || !Customer || !excelInput || saving" :loading="processing">Process Data</v-btn>
          </v-layout>
          <div v-if="dataProcessed" class="mt-5">
            <span class="title">Output Data</span>
            <v-data-table :pagination.sync="pagination" hide-actions :items="processedData" :headers="headers">
              <template slot="items" slot-scope="props">
                <tr :class="{'red': props.item.duplicate}">
                  <td>{{props.item.VehicleReg}}</td>
                  <td>{{props.item.FleetNumber}}</td>
                  <td>{{props.item.Make}}</td>
                  <td>{{props.item.Model}}</td>
                  <td>{{props.item.Year}}</td>
                  <td>{{props.item.Type}}</td>
                  <td>{{props.item.VUPartNo}}</td>
                  <td>{{props.item.FuelTankSize}}</td>
                  <td>{{props.item.AdditionalInfo}}</td>
                </tr>
              </template>
            </v-data-table>
            <v-layout align-center>
              <v-spacer></v-spacer>
              <v-checkbox class="shrink" label="I confirm the above output is correct" v-model="dataLooksGood"></v-checkbox>
              <v-btn color="primary" @click="saveData" :disabled="!dataLooksGood || containsDups" :loading="saving">Save Vehicles</v-btn>
            </v-layout>
          </div>
        </v-card-text>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
import { fireStore } from '../../firebase'
export default {
  props: ['parentCustomer', 'customerFixed'],
  data () {
    return {
      siteDialog: false,
      dialog: false,
      excelInput: '',
      includeHeaders: false,
      dataProcessed: false,
      processing: false,
      saving: false,
      processedData: [],
      headers: [{
        text: 'Vehicle Reg.',
        value: 'VehicleReg',
        align: 'left'
      },
      {
        text: 'Fleet No.',
        value: 'FleetNumber',
        align: 'left'
      },
      {
        text: 'Make',
        value: 'Make',
        align: 'left'
      },
      {
        text: 'Model',
        value: 'Model',
        align: 'left'
      },
      {
        text: 'Year',
        value: 'Year',
        align: 'left'
      },
      {
        text: 'Type',
        value: 'Type',
        align: 'left'
      },
      {
        text: 'VU Part Number',
        value: 'VUPartNo',
        align: 'left'
      },
      {
        text: 'Fuel Tank Size',
        value: 'FuelTankSize',
        align: 'left'
      },
      {
        text: 'Additional Information',
        value: 'AdditionalInfo',
        align: 'left'
      }],
      pagination: {rowsPerPage: -1},
      dataLooksGood: false,
      gettingCustomers: false,
      customerList: [],
      sites: [],
      Customer: null,
      Site: null,
      vehicles: [],
      containsDups: false
    }
  },
  created () {
    this.getCustomers()
  },
  mounted () {
    this.sites = []
    this.Customer = this.parentCustomer
    this.getVehicles()
  },
  watch: {
    parentCustomer: function (val) {
      this.Customer = val
    },
    siteDialog: function (val) {
      if (!val) {
        this.getSites()
      }
    },
    Customer: function (val) {
      if (val) {
        this.getSites()
      }
    }
  },
  computed: {
    userData () {
      return this.$store.getters.userData
    }
  },
  methods: {
    getVehicles () {
      this.vehicles = []
      fireStore.collection('Vehicles')
      .get()
      .then(snap => {
        snap.forEach(doc => {
          let data = doc.data()
          data.id = doc.id
          this.vehicles.push(data)
        })
      })
    },
    getCustomers () {
      this.gettingCustomers = true
      fireStore.collection('Customers').get()
      .then(snap => {
        snap.forEach(doc => {
          this.customerList.push({key: doc.id, name: doc.data().customerName, shortName: doc.data().shortName})
        })
        this.customerList.sort(function (a, b) {
          const aName = a.name.toLowerCase()
          const bName = b.name.toLowerCase()
          return aName < bName ? -1 : aName > bName ? 1 : 0
        })
        this.gettingCustomers = false
      })
    },
    getSites () {
      this.sites = []
      fireStore.collection('Sites').where('Customer', '==', this.Customer)
      .get()
      .then(snap => {
        snap.forEach(doc => {
          this.sites.push({key: doc.id, name: doc.data().Name})
        })
      })
    },
    processRawData () {
      console.log('processing')
      this.processing = true
      this.processedData = []
      let rows = []
      rows = this.excelInput.split('\n')
      if (this.includeHeaders) {
        rows.splice(0, 1)
      }
      this.containsDups = false
      rows.forEach(row => {
        if (row === '') {
          return
        }
        const cols = row.split('\t')
        const obj = {
          VehicleReg: cols[0] ? cols[0] : '',
          FleetNumber: cols[1] ? cols[1] : '',
          Make: cols[2] ? cols[2] : '',
          Model: cols[3] ? cols[3] : '',
          Year: cols[4] ? cols[4] : '',
          Type: cols[5] ? cols[5] : '',
          VUPartNo: cols[6] ? cols[6] : '',
          FuelTankSize: cols[7] ? cols[7] : '',
          AdditionalInfo: cols[8] ? cols[8] : '',
          Site: this.Site,
          Customer: this.Customer
        }
        obj.VehicleReg = obj.VehicleReg.replace(/ /g, '').toUpperCase()
        let vIndex = this.vehicles.findIndex((v) => {
          return obj.VehicleReg === v.VehicleReg ? v.VehicleReg.replace(/ /g, '').toUpperCase() : null
        })
        if (vIndex !== -1) {
          obj.duplicate = true
          this.containsDups = true
        } else {
          obj.duplicate = false
        }
        this.processedData.push(obj)
      })
      this.dataProcessed = true
      this.processing = false
      if (this.containsDups) {
        alert('You are trying to add vehicles that are already in the system. Please remove any duplicates and try again.')
      }
    },
    saveData () {
      console.log('saving')
      this.saving = true
      let promises = []
      let regs = []
      fireStore.collection('Vehicles').get()
      .then(snap => {
        let vehicleFriendlyIds = ['0']
        snap.forEach(doc => {
          const data = doc.data()
          if (data.friendlyId) {
            if (data.friendlyId.indexOf('CUBO') > -1 && data.friendlyId.indexOf('NaN') === -1) {
              let number = data.friendlyId.replace('CUBO', '')
              if (!isNaN(number)) {
                vehicleFriendlyIds.push(parseInt(number))
              }
            }
          }
        })
        vehicleFriendlyIds.sort(function (a, b) {
          return a - b
        }).reverse()
        let friendlyId = vehicleFriendlyIds[0]
      // fireStore.collection('Vehicles').get()
      // .then(snap => {
      //   let vehicleFriendlyIds = ['0']
      //   snap.forEach(doc => {
      //     const data = doc.data()
      //     if (data.friendlyId) {
      //       if (data.friendlyId.indexOf('NIBC') > -1 && data.friendlyId.indexOf('NaN') === -1) {
      //         vehicleFriendlyIds.push(data.friendlyId.replace('NIBC', ''))
      //       }
      //     }
      //   })
      //   vehicleFriendlyIds.sort().reverse()
        // let friendlyId = vehicleFriendlyIds[0]
        this.processedData.forEach((vehicleObj, i) => {
          regs.push(vehicleObj.VehicleReg)
          promises[i] = new Promise((resolve, reject) => {
            friendlyId = this.zeroFill((parseInt(friendlyId) + 1), 5)
            vehicleObj.friendlyId = 'CUBO' + friendlyId
            if (!vehicleObj.vehReg || vehicleObj.vehReg.length < 1) {
              vehicleObj.vehReg = vehicleObj.friendlyId
            }
            vehicleObj.Added = Date.now()
            fireStore.collection('Vehicles').add(vehicleObj)
              .then(result => {
                this.processedData[i]['id'] = result.id
                resolve(result)
              })
              .catch(error => {
                reject(error)
              })
          })
        })
        Promise.all(promises).then(values => {
          const vehicleAmount = this.processedData.length
          console.log(values)
          const logObj = {
            uid: this.userData.UID,
            name: this.userData.Name,
            action: 'Bulk added ' + vehicleAmount + ' vehicles.',
            customer: this.Customer,
            vehicleRegs: regs
          }
          console.log(logObj)
          fireStore.collection('Log').add(logObj)
          .then(ref => {
            console.log(ref)
          })
          .catch(error => {
            console.log(error)
          })
          .then(() => {
            this.saving = false
            this.$emit('vehiclesAdded', this.processedData)
            this.close()
          })
        })
      })
    },
    close () {
    //   this.$emit('update:dialog', false)
      this.dialog = false
      setTimeout(() => {
        this.excelInput = ''
        this.processedData = []
        this.Site = null
        this.dataLooksGood = false
        this.sites = []
        this.dataProcessed = false
      }, 300)
    },
    zeroFill (number, width) {
      width -= number.toString().length
      if (width > 0) {
        return new Array(width + (/\./.test(number) ? 2 : 1)).join('0') + number
      }
      return number
    }
  }
}
</script>


// WEBPACK FOOTER //
// BulkAddVehicleDialog.vue?80bb288c